import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

/**
 * Remove one video from the push, from Step 3 (user request 2026-10-14) —
 * the same as its × in Step 2. Asks first only when something set up for it
 * would be lost: a picked file, an edit, or a custom thumbnail.
 */
export default function RemoveVideoButton({ video, pairConfigs, onRemove }) {
  const [asking, setAsking] = useState(false);
  const name = video.title || video.video_title || video.unique_key;
  const hasWork = (pairConfigs || []).some(
    (c) => c && (c.local_video_file || c.render_payload || c.local_thumb_file)
  );

  const click = () => {
    if (hasWork) setAsking(true);
    else onRemove(video.unique_key);
  };

  return (
    <>
      <Tooltip title="Remove this video from the push">
        <IconButton
          size="small"
          color="error"
          onClick={click}
          aria-label={`Remove ${name} from the push`}
          data-testid={`remove-video-${video.unique_key}`}
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Dialog open={asking} onClose={() => setAsking(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 700 }}>Remove {video.unique_key} from this push?</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary">
            The file, edit or thumbnail you set up for it will be lost. You can add it again in Step 2.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setAsking(false)} sx={{ textTransform: "none", fontWeight: 600 }}>
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={() => {
              setAsking(false);
              onRemove(video.unique_key);
            }}
            sx={{ textTransform: "none", fontWeight: 700 }}
            data-testid="remove-video-confirm"
          >
            Remove video
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
